import { Box, Flex, theme } from '@bnb-chain/space';

import { Footer } from '@/core/components/Layout/Footer';
import { Header } from '@/core/components/Layout/Header';

export function Layout({ children }: React.PropsWithChildren) {
  return (
    <Flex display="flex" flexDir="column" minH="100vh" position="relative">
      <Header zIndex={10} />
      <Flex
        position="relative"
        as="main"
        flexDir="column"
        flex={1}
        p={{ base: 0, md: theme.sizes['6'] }}
        pt={{ base: '88px', md: '104px' }}
        alignItems="center"
        overflow="hidden"
      >
        <Box
          display={{ base: 'none', md: 'block' }}
          position={'absolute'}
          bg={
            'radial-gradient(50% 50% at 50% 50%, rgba(255, 233, 0, 0.70) 0%, rgba(0, 0, 0, 0.00) 100%)'
          }
          opacity={0.25}
          w={'189.267vw'}
          h={'47.57vw'}
          left={'50%'}
          bottom={0}
          transform={`translate(-50%, 53%)`}
          pointerEvents={'none'}
        />
        <Box w={'100%'} position={'relative'} sx={{ '>div': { mb: theme.sizes['4'] } }}>
          {children}
        </Box>
      </Flex>
      <Footer />
    </Flex>
  );
}
